<template><!--template can have only one child, so we use session for it-->
  <div style="display:flex;flex:1 1 auto;flex-direction: column">
    <div style="display:flex;align-items:center;justify-content:center;padding:10px 0">
      <i class="fa fa-th" style="margin:0 4px;padding-top:2px"></i>
      <h4 class="nowrap">รายงานผลการวาดแปลง</h4>
    </div>
    <div style="padding:8px 10px">
      use vuetify v-expansion-panel
    </div>
  </div>
</template>

<script>
export default {
}
</script>
